<template>
  <div class="order-details-component">
    <div class="details-container flex">
      <div class="details-content flex a-center">
        <!-- Мобилка только для просмотра: вместо действий - имя и телефон клиента -->
        <div
          v-if="isMobileLayout"
          class="client-section d-flex flex-column"
        >
          <span class="label">Клиент:</span>
          <span v-if="hasClientPhone" class="client-title">
            <font-awesome-icon
              class="client-icon"
              :class="{ nocall: isNoCall }"
              color="#000000"
              icon="phone-alt"
            />
            <span>{{ clientName }}</span>
            <span class="font-weight-medium">{{ clientPhone }}</span>
          </span>
          <span v-else class="client-title client-title__anonim">
            Клиент без регистрации
          </span>
        </div>
        <template v-else>
          <v-btn
            v-if="isReadyToPreparing"
            class="cooking-btn"
            large
            color="primary"
            rounded
            depressed
            :loading="loadingOrderAction"
            @click="onPreparingClick"
          >
            Готовить
          </v-btn>
          <v-btn
            v-else-if="isReadySelfDeliveryOrder"
            class="cooking-btn"
            large
            color="success"
            rounded
            depressed
            :loading="loadingOrderAction"
            @click="completeSelfDeliveryOrder"
          >
            <template v-if="isPayedOrder">
              Завершить заказ
            </template>
            <template v-else>
              Оплатить и завершить
            </template>
          </v-btn>
          <client-phone-btn
            v-else
            :order="order"
            rounded
          />
        </template>
        <!--        <div class="client-phone-section">
          <component
            :is="order.client.phone ? 'button' : 'span'"
            @click="emitCallback"
            class="client-phone d-inline-flex align-center"
            :class="{ 'client-phone-active': order.orderStatus === 'new' }"
          >
            <font-awesome-icon
              v-if="order.client.phone"
              class="client-phone-icon"
              :class="{nocall: order.basket.noCall }"
              width="19px"
              icon="phone-alt"
            />
            <span class="d-flex flex-column">
              <template v-if="order.client.phone">
                <span class="name">{{ order.client.name }}</span>
                <span class="number font-weight-medium">{{ order.client.phone }}</span>
              </template>
              <span v-else class="name anonim">
                Клиент без регистрации
              </span>
            </span>
          </component>
        </div>-->

        <div class="divider" />

        <div class="address-section d-flex flex-column">
          <span class="label">Адрес доставки:</span>
          <span
            v-if="order.clientAddress"
            class="address-title"
          >
            <font-awesome-icon
              color="#000000"
              icon="map-marker-alt"
            />
            {{ order.clientAddress.street }} д. {{ order.clientAddress.house }},
            кв {{ order.clientAddress.apartmentNumber }}
          </span>
          <span
            v-else-if="order.deliveryType == 'self'"
            class="address-title pickup"
          >Самовывоз</span>
          <span
            v-else
            class="address-title"
          >–</span>
          <span class="courier">
            <font-awesome-icon
              color="#000000"
              icon="walking"
            />
            {{ getCourierInfo }}
          </span>
        </div>

        <div class="divider" />

        <div class="payment-info-section d-flex">
          <span class="pay-number">
            {{ order.totalPrice | amountWithCurrency }}
            <promo-code-badge
              class="promocode"
              :promo-code="order.basket.promoCode"
              :discount-amount="order.discountAmount"
            />
            <span
              v-if="showFoxCoinPay"
              class="foxcoins-pay"
            >-{{ order.foxCoinsPayAmount }}</span>
          </span>

          <div class="info-section d-flex flex-column">
            <span class="label">Тип оплаты:</span>
            <span class="pay-type font-weight-medium">
              <font-awesome-icon
                color="#000000"
                icon="wallet"
              />
              {{ getPaymentType }}
            </span>

            <span
              v-if="order.basket.clientMoney && order.paymentType === 'cash'"
              class="pay-change"
            >
              <font-awesome-icon
                color="#000000"
                icon="coins"
              />
              <span>
                <span>сдача с
                  <span class="font-weight-medium">{{ order.basket.clientMoney }} ₽</span></span> <br>
                <span v-if="clientMoneyRest">подготовить:
                  <span class="font-weight-medium">{{ clientMoneyRest }} ₽</span></span>
              </span>
            </span>

            <!-- Мобильная вёрстка: промокод под типом оплаты, на десктопе он рядом с суммой -->
            <div v-if="hasPromoInfo" class="mobile-promocode-section">
              <promo-code-badge
                class="promocode"
                :promo-code="order.basket.promoCode"
                :discount-amount="order.discountAmount"
              />
              <span
                v-if="showFoxCoinPay"
                class="foxcoins-pay"
              >-{{ order.foxCoinsPayAmount }}</span>
            </div>

            <payment-status-tag style="margin-top: 5px;" :order="order" />
          </div>
        </div>

        <div class="divider" />

        <div class="branch-section d-flex flex-column">
          <!-- Компактный десктоп: филиала в листинге нет, на его месте таймер заказа -->
          <order-dead-line-timer
            v-if="isCompactScreen"
            class="branch-section-timer"
            :dead-line="order.deadLine"
            :stopped-at="order.timerStoppedAt"
            :stop-reason="order.timerStopReason"
            @lateness="setOrderLateness"
          />
          <div v-else class="branch-info-block">
            <span class="label">Филиал:</span>
            <span class="branch-info">
              <font-awesome-icon
                color="#000000"
                icon="store-alt"
              />
              <span class="font-weight-medium">{{ getFilialName }}</span>
            </span>
          </div>

          <div
            class="order-deadline-time"
            :class="{'preorder': isPreorder}"
          >
            <font-awesome-icon
              icon="clock"
              class="mr-3"
            />
            <span class="font-weight-medium">~{{ getOrderDeadlineTime }} / {{ getOrderRemainingMinutes }}</span>
          </div>
        </div>
      </div>

      <div class="details-timer-section flex a-center j-between">
        <div v-if="!isCompactScreen" class="remaining-time-section d-flex flex-column">
          <order-dead-line-timer
            :dead-line="order.deadLine"
            :stopped-at="order.timerStoppedAt"
            :stop-reason="order.timerStopReason"
            @lateness="setOrderLateness"
          />
        </div>

        <div class="order-details-section flex flex-column a-center">
          <v-btn
            v-if="isMobileLayout"
            class="mobile-details-btn"
            color="#f1f3f6"
            depressed
            block
            @click="openCourierInfo"
          >
            <font-awesome-icon
              class="mobile-details-btn_icon"
              icon="info-circle"
            />
            Детали заказа
          </v-btn>
          <button
            v-else
            class="button-info flex flex-column a-center"
            @click="openCourierInfo"
          >
            <font-awesome-icon
              color="#DBDFE6"
              icon="info-circle"
            />
            <span class="label">Детали заказа</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Предзаказ: готовить раньше срока - осознанное решение, спрашиваем -->
    <primary-confirm-dialog
      v-model="showPreparingConfirm"
      :loading="loadingOrderAction"
      :persistent="false"
      close-after-loading
      title="Начать готовить предзаказ?"
      :subtitle="preorderConfirmSubtitle"
      confirm-text="Готовить"
      @confirm="startPreparing"
    />

    <!-- Самовывоз готов к выдаче и оплачен: завершение необратимо, спрашиваем -->
    <primary-confirm-dialog
      v-model="showCompleteConfirm"
      :loading="loadingOrderAction"
      :persistent="true"
      close-after-loading
      :title="completeConfirmTitle"
      confirm-text="Завершить"
      confirm-btn-color="success"
      @confirm="completeOrder"
    />
  </div>
</template>

<script>
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  // import { DateTime, Duration } from 'luxon'
  import PaymentStatusTag from '@/components/order-card/PaymentStatusTag.vue'
  import PaymentMode from '@/models/enums/PaymentMode'
  import PromoCodeAction from '@/models/enums/PromoCodeAction'
  import PaymentType from '@/models/enums/PaymentType'
  import DeliveryType from '@/models/enums/DeliveryType'
  import { formatIsoDateTimeAsTime, formatIsoDateTimeAsDateTime } from '@/util/date-time-helper'
  import OrderDeadLineTimer from '@/components/order-card/OrderDeadLineTimer'
  import OrderStatus from '@/models/enums/OrderStatus'
  import ClientPhoneBtn from '@/components/order-card/ClientPhoneBtn.vue'
  import PrimaryConfirmDialog from '@/components/ui/dialogs/PrimaryConfirmDialog.vue'
  import PaymentStatus from '@/models/enums/PaymentStatus'
  import compactScreen from '@/mixins/compact-screen'

  export default {
    name: 'OrderDetails',
    components: { ClientPhoneBtn, OrderDeadLineTimer, PaymentStatusTag, PrimaryConfirmDialog },
    mixins: [mixinSnackbarMessage, compactScreen],
    props: {
      order: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {
        deadLineTime: '00:00',
        deadLineTimeout: null,
        timeDifference: 0,
        loadingOrderAction: false,
        showPreparingConfirm: false,
        showCompleteConfirm: false,
      }
    },
    computed: {
      // Граница совпадает с LESS-миксином .media-lg (@lg: 1024px) и с isMobile в OrderCard
      isMobileLayout () {
        return this.$vuetify.breakpoint.width <= 1024
      },
      hasClientPhone () {
        return !!this.order?.client?.phone
      },
      // Тот же порядок полей, что в ClientPhoneBtn: отформатированный номер приоритетнее
      clientPhone () {
        return this.order?.client?.formattedPhone || this.order?.client?.phone
      },
      clientName () {
        return this.order?.client?.name || 'Без имени'
      },
      isNoCall () {
        return !!this.order?.basket?.noCall
      },
      isReadyToPreparing () {
        return this.order?.orderStatus === OrderStatus.Confirm
      },
      isPreorder () {
        return (
          this.order.basket &&
          this.order.basket.toDatetime &&
          this.order.basket.dateDelivery
        )
      },
      deliveryType () {
        return this.order.basket?.deliveryType
      },
      preorderDeliveryLabel () {
        return formatIsoDateTimeAsDateTime(this.order.basket?.dateDelivery)
      },
      preorderConfirmSubtitle () {
        let preorderDeliveryLabel = ''
        if (this.deliveryType === DeliveryType.Self) {
          preorderDeliveryLabel += 'Самовывоз '
        } else if (this.deliveryType === DeliveryType.Delivery) {
          preorderDeliveryLabel += 'Доставка '
        }

        preorderDeliveryLabel += this.preorderDeliveryLabel
        return preorderDeliveryLabel
      },
      isReadySelfDeliveryOrder () {
        return (
          this.deliveryType === DeliveryType.Self &&
          this.order.orderStatus === OrderStatus.ReadyForIssue
        )
      },
      isPayedOrder () {
        return this.order?.payment?.status === PaymentStatus.Success
      },
      orderCode () {
        return this.order.formattedCode || this.order.code
      },
      completeConfirmTitle () {
        return `Завершить заказ #${this.orderCode}?`
      },
      isOrderFinished () {
        return this.order.orderStatus === OrderStatus.Completed ||
          this.order.orderStatus === OrderStatus.Canceled
      },
      clientMoneyRest () {
        if (this.order.basket.clientMoney > 0) {
          return this.order.basket.clientMoney - this.order.totalPrice
        }
        return 0
      },
      // Пустой блок на мобилке всё равно держал margin-bottom и раздувал отступ
      hasPromoInfo () {
        return !!(this.showPromocode || this.showDiscount || this.showFoxCoinPay)
      },
      showPromocode () {
        return this.order.basket.promoCode &&
          this.order.basket.promoCode.promoCode &&
          // this.order.basket.promoCode.promoCode.name &&
          this.order.basket.promoCode.promoCode.action !== PromoCodeAction.FoxCoinPay
      },
      showDiscount () {
        return !this.order.basket.promoCode && this.order.discountAmount
      },
      showFoxCoinPay () {
        return this.order.basket.promoCode &&
          this.order.basket.promoCode.promoCode &&
          this.order.basket.promoCode.promoCode.action === PromoCodeAction.FoxCoinPay
      },
      getOrderDeadlineTime () {
        return formatIsoDateTimeAsTime(this.order.deadLine, '')
      },
      getOrderRemainingMinutes () {
        return Math.ceil(this.order.basket.cookingAndDeliveryTime / 60) + ' мин'
      },
      getCourierInfo () {
        if (this.order.courier) {
          return this.order.courier.name
        }

        if (this.order.basket.deliveryType === DeliveryType.DeliveryClub) {
          return 'Delivery Club'
        }

        if (this.order.basket.deliveryType === DeliveryType.Yandex) {
          return 'Яндекс.Еда'
        }

        if (this.order.basket.deliveryType === DeliveryType.Aggregator) {
          return 'Курьер агрегатора'
        }

        return '-'
      },
      getFilialName () {
        // return this.order.filial ? this.order.filial.name : '–'
        return `${this.order?.filial?.city}, ${this.order?.filial?.address}`
      },
      getPaymentType () {
        if (this.order.paymentType) {
          return PaymentType.getName(this.order.paymentType, this.order.deliveryType, PaymentMode.ofOrder(this.order))
        }
        return '–'
      },
    },
    watch: {
      timeDifference () {
        const isTimerPositive = this.timeDifference > 0
        this.$emit('updateStepperStatus', isTimerPositive)
      },
      /* order: {
        handler () {
          if (this.order.orderStatus === 'completed' || this.order.orderStatus === 'canceled') {
            clearInterval(this.deadLineTimeout)
            this.getRemainingTime()
          } else {
            this.setTimer()
          }
        },
        deep: true,
      }, */
    },
    mounted () {
      /* if (this.order.orderStatus !== 'completed' && this.order.orderStatus !== 'canceled') {
        this.setTimer()
      } else {
        this.getRemainingTime()
      } */
    },
    beforeDestroy () {
      // clearInterval(this.deadLineTimeout)
    },
    methods: {
      onPreparingClick () {
        if (this.isPreorder) {
          this.showPreparingConfirm = true
          return
        }
        this.startPreparing()
      },
      // Повторяет «Оплатить и завершить» из CourierInfo: неоплаченный - в диалог оплаты
      // (после оплаты заказ завершает бэк), оплаченный - подтверждение и следующий статус
      completeSelfDeliveryOrder () {
        if (!this.isPayedOrder) {
          this.pay()
          return
        }
        this.showCompleteConfirm = true
      },
      pay () {
        this.$store.commit('orders/setCurrentEditOrder', this.order)
        this.$store.commit('baskets/setBasket', this.order.basket)
        this.$store.commit('orders/setShowPaymentDialog', true)
      },
      async completeOrder () {
        this.loadingOrderAction = true
        try {
          await this.$store.dispatch('orders/changeOnNextStatus', this.order.id)
        } catch (e) {
          this.showErrorFromResponse(e)
        }
        this.loadingOrderAction = false
      },
      async startPreparing () {
        this.loadingOrderAction = true
        try {
          await this.$store.dispatch('orders/startPreparing', this.order.id)
        } catch (e) {
          this.showErrorFromResponse(e)
        }
        this.loadingOrderAction = false
      },
      setOrderLateness (eventValue) {
        this.$store.commit('orders/setOrderLateness', {
          id: this.order.id,
          value: eventValue,
        })
      },

      openCourierInfo () {
        this.$store.commit('orders/setCurrentEditOrder', {})
        this.$emit('openCourierInfo')
      },
      /* getRemainingTime () {
        if (!this.order.deadLine) {
          return false
        }
        let completeDatatime = ''
        if (this.order.orderStatus === 'completed') {
          completeDatatime = DateTime.fromFormat(this.order.orderCompletedAt, 'yyyy-MM-dd HH:mm:ss').toMillis()
        } else {
          completeDatatime = DateTime.fromFormat(this.order.orderCanceledAt, 'yyyy-MM-dd HH:mm:ss').toMillis()
        }
        const deadLine = DateTime.fromFormat(this.order.deadLineString, 'yyyy-MM-dd HH:mm:ss').toMillis()
        this.timeDifference = Duration.fromMillis(deadLine - completeDatatime).as('milliseconds')
        this.deadLineTime = Duration.fromMillis(Math.abs(this.timeDifference)).toFormat('mm:ss')
        if (this.timeDifference < 0) {
          this.deadLineTime = `-${this.deadLineTime}`
        }
      }, */
      /*  setTimer () {
        if (!this.order.deadLine) {
          return false
        }
        const currentDatetime = DateTime.local()
        const deadLine = DateTime.fromISO(this.order.deadLine)
        this.timeDifference = deadLine.diff(currentDatetime, 'seconds')

        clearInterval(this.deadLineTimeout)
        this.deadLineTimeout = setInterval(() => {
          const minutes = Duration.fromMillis(Math.abs(this.timeDifference)).toFormat('mm:ss')
          if (this.timeDifference < 0) {
            this.deadLineTime = `-${minutes}`
          } else {
            this.deadLineTime = `${minutes}`
          }
          this.timeDifference -= 1000
        }, 1000)
      }, */
    },
  }
</script>

<style lang="less" scoped>
  //noinspection ALL
  .order-details-component {
    display: flex;
    align-items: center;
    padding-left: 15px;
    padding-right: 24px;
    padding-top: 20px;
    font-size: 13px;

    // Мобильные экраны (<=768px): плотный горизонтальный ряд карточки
    // разворачивается в колонку, секции и кнопка на всю ширину, разделители
    // становятся горизонтальными - чтобы карточка не вылазила за экран.
    .media-sm({
      align-items: stretch;
      padding: 12px;

      .details-container {
        flex-direction: column;
        width: 100%;
      }

      .details-content {
        width: 100%;
      }

      .cooking-btn {
        max-width: 100%;
        width: 100%;
        margin-right: 0;
        margin-bottom: 10px;
      }

      .divider {
        width: 100%;
        height: 1px;
        margin: 8px 0;
      }

      .address-section,
      .branch-section,
      .info-section,
      .remaining-time-section {
        width: 100%;
      }

      .payment-info-section {
        flex-wrap: wrap;
        margin-left: 0;
        width: 100%;
      }

      .details-timer-section {
        width: 100%;
        margin-top: 10px;
      }
    });

    .cooking-btn {
      max-width: 200px;
      width: 200px;
      margin-right: 24px;

      @media (max-width: 1700px) {
        max-width: 165px;
        width: 165px;
        margin-right: 15px;
      }
    }

    .order-deadline-time.preorder {
      color: #E91E63;
    }

    .media-xl({
      font-size: 14px;
      padding-left: 19px;
      padding-right: 30px;
      padding-top: 25px;
    });

    .divider {
      height: 68px;
      width: 1px;
      background-color: #dbdbdb;
    }

    .client-section {
      span {
        display: inline-block;
        color: #000000;
      }

      .client-title {
        display: flex;
        align-items: baseline;
        gap: 8px;
        font-size: 15px;
        line-height: 1.2;

        &__anonim {
          color: #7b7b7b;
        }
      }

      // Как в ClientPhoneBtn: зелёная трубка = клиент просил не звонить
      .client-icon.nocall {
        ::v-deep path {
          fill: #1ee984 !important;
        }
      }
    }

    .address-section {
      margin-left: 12px;
      margin-right: 12px;

      span {
        display: inline-block;
        color: #000000;

        svg {
          margin-right: 7px;
        }
      }

      .label {
        margin-bottom: 5px;
        font-size: 11px;
        line-height: 1.2;
        .media-xl({
          font-size: 14px;
          line-height: 17px;
        });
      }

      .address-title {
        margin-bottom: 10px;
        font-size: 13px;
        line-height: 1.2;
        .media-xl({
          font-size: 16px;
          line-height: 19px;
          margin-bottom: 12px;
        });

        &.pickup {
          //color: #38b2b2;
          color: #e91e63;
          font-weight: bold;
        }
      }
    }

    // Рамка и скругление - в PromoCodeBadge, здесь только размер и место
    .promocode {
      font-size: 10px;
      min-height: 24px;
      margin-top: 5px;
      max-width: 150px;
      padding: 0 4px;
      .media-xl({
        font-size: 12px;
      })
    }

    .foxcoins-pay {
      font-size: 13px;
      color: #fe9923;
      display: flex;
      align-items: center;
      line-height: 1.2;
      font-weight: bold;

      &:after {
        display: inline-block;
        height: 16px;
        width: 16px;
        content: '';
        background: url("/img/icons/setcoins-icon.svg") no-repeat center center;
        background-size: contain;
        margin-left: 2px;
        margin-top: -3px;
      }

      .media-xl({
        font-size: 16px;

        &:after {
          height: 20px;
          width: 20px;
        }
      });

    }
    .mobile-promocode-section {
      display: none;
    }

    .payment-info-section {
      margin-top: -3px;
      margin-left: 10px;
      margin-right: 15px;
      align-items: center;
      flex-direction: row;
      flex-wrap: nowrap;

      @media (min-width: 1025px) and (max-width: 1400px) {
        flex-direction: column;
        align-items: flex-start;

        .info-section .label {
          display: none;
        }
      }
      .media-xl({
        margin-left: 17px;
        margin-right: 25px;
      });

      .label {
        line-height: 1;
      }

      .pay-number {
        margin-right: 20px;
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 9px;
        white-space: nowrap;

        .media-xl({
          font-size: 30px;
          line-height: 41px;
          margin-right: 25px;
          margin-bottom: 11px;
        });

        @media (min-width: 1025px) and (max-width: 1400px) {
          margin-bottom: 4px;
          line-height: 1.2;
          font-size: 22px;
          display: flex;
          align-items: center;

          .promocode,
          .foxcoins-pay {
            margin-top: 0;
            margin-left: 10px;
          }
        }
      }

      .info-section {
        span {
          display: inline-block;
        }

        .label {
          margin-bottom: 3px;
        }

        .pay-type {
          margin-bottom: 12px;
          white-space: nowrap;

          svg {
            margin-right: 7px;
          }

          @media (min-width: 1025px) and (max-width: 1400px) {
            margin-bottom: 5px;
          }
        }

        .pay-change {
          line-height: 19px;
          margin-top: -10px;
          display: flex;
          align-items: center;

          svg {
            margin-right: 7px;
          }
        }
      }
    }

    .branch-section {
      align-self: stretch;
      margin-left: 16px;
      flex-basis: 20%;
      justify-content: center;

      @media (max-width: 1700px) {
        flex-basis: 15%;
      }

      .branch-info-block {
        margin-bottom: 10px;
        display: flex;
        flex-direction: column;
        line-height: 1.2;
        font-size: 13px;

        .label {
          margin-bottom: 3px;
          font-size: 13px;
        }

        @media (max-width: 1700px) {
          font-size: 12px;
        }
      }

      .branch-info {
        display: flex;
        svg {
          margin-right: 8px;
        }

      }
    }

    .remaining-time-section {
      margin-left: 15px;
      margin-right: 30px;

      .media-xl({
        margin-left: 30px;
        margin-right: 46px;
      });
    }

    .order-details-section {
      .label {
        font-size: 14px;
      }

      .button-info {
        margin-bottom: 6px;
        width: 30px;

        svg {
          width: 30px;
          height: 30px;
        }
      }

      @media (max-width: 1700px) {
        .label {
          font-size: 11px;
        }
      }
    }

    @media (min-width: @md) {
      .details-container {

        .details-content {
          & > .d-flex {
            flex-grow: 1;
          }
          .client-phone-section {
            //flex-basis: 21%;

            .client-phone {
              min-height: 54px;
              .name.anonim {
                text-align: center;
                margin-top: -3px;
              }
            }
          }

          .address-section {
            flex-basis: 20%;
            max-height: 80px;
            justify-content: space-around;
          }

        }

        .details-timer-section {
          max-width: 215px;
          .order-details-section {
            max-width: 75px;

            svg {
              margin-bottom: 6px;
            }

            .label {
              line-height: 1.1;
            }
          }

          .remaining-time-section {
            min-width: 80px;
          }

          @media (max-width: 1700px) {
            max-width: 150px;
          }
        }

      }
    }

    // Компактный десктоп: филиала нет, на его месте таймер заказа. Колонка таймера
    // и кнопка деталей фиксированной ширины и прижаты вправо - таймеры стоят на одной
    // вертикали во всех карточках; свободную ширину забирает адрес
    .media-compact-pc({
      .details-container {
        .details-content {
          flex: 1 1 0;
          min-width: 0;

          // Кнопка действия: подпись крупнее и может перейти на вторую строку -
          // «Оплатить и завершить» в одну упирается в края кнопки
          .cooking-btn {
            padding: 0 12px;
            font-size: 13px;
            font-weight: 500;

            ::v-deep .v-btn__content {
              flex: 1 1 auto;
              white-space: normal;
              text-align: center;
              line-height: 1.2;
            }
          }

          // без max-height: на 1025px адрес занимает три строки, и курьер
          // под ним выезжал на линию статусов
          .address-section {
            flex: 1 1 0;
            min-width: 0;
            max-height: none;
          }

          .payment-info-section {
            flex: 0 0 auto;
          }

          .branch-section {
            flex: 0 0 136px;
          }
        }

        .details-timer-section {
          flex: 0 0 auto;
          margin-left: 8px;

          // подпись «Детали заказа» шире самой кнопки-иконки
          .order-details-section {
            width: 56px;
          }
        }
      }

      // Сетка в одну колонку по ширине самой длинной строки: таймер встаёт
      // по центру строки времени доставки, а сама строка остаётся у левого края.
      // !important - у .d-flex от Vuetify display с !important
      .branch-section {
        display: grid !important;
        grid-template-columns: max-content;
        justify-content: start;
        justify-items: center;
        align-content: center;

        // время доставки под таймером
        .order-deadline-time {
          margin-top: 12px;
          white-space: nowrap;

          svg {
            margin-right: 6px !important;
          }
        }
      }
    });

    .media-lg({
      padding: 15px 10px;
      .divider {
        display: none;
      }
      .details-container {
        flex-direction: column;
      }
      .details-content {
        flex-direction: column;
        align-items: flex-start;
        // nowrap обязателен: в колонке wrap уносит блоки во вторую колонку
        flex-wrap: nowrap;
      }
      .mobile-promocode-section {
        display: block;
        margin-bottom: 8px;
      }
      // После строки «сдача с ...» у неё нет нижнего отступа
      .pay-change + .mobile-promocode-section {
        margin-top: 8px;
      }
      // Правило .payment-info-section .info-section span { display: inline-block } сильнее
      // стилей плашки, поэтому flex возвращаем на той же вложенности
      .payment-info-section .info-section .mobile-promocode-section {
        .promocode,
        .foxcoins-pay {
          display: flex;
          margin-top: 0;
        }
      }
      .client-phone-section {
        display: none;
      }

      // Один отступ и одна вертикаль текста у всех информационных блоков
      .client-section,
      .address-section,
      .payment-info-section,
      .branch-section {
        width: 100%;
        margin: 0 0 12px;
        padding: 0;
        // десктопные flex-basis (20% / 15%) в колонке превращаются в высоту
        flex: 0 0 auto;

        & > .label,
        .info-section > .label,
        .branch-info-block > .label {
          font-size: 13px;
          line-height: 1.2;
          margin-bottom: 4px;
        }
      }

      // У .client-section иконка отбита через gap в самом блоке, здесь только
      // остальные три: одинаковая ширина иконки = одна вертикаль текста
      .address-section,
      .payment-info-section,
      .branch-section {
        svg {
          width: 16px;
          margin-right: 8px;
        }
      }

      .payment-info-section {
        justify-content: flex-start;

        .pay-number {
          display: none;
        }
      }

      .branch-section {
        .order-deadline-time {
          display: none;
        }

        // Время доставки скрыто, и этот отступ дублировал отступ самой секции
        .branch-info-block {
          margin-bottom: 0;
        }
      }

      .remaining-time-section {
        margin-left: 0;
        margin-right: 0;
        flex: 1;
        justify-content: center;
        display: none !important;
        span {
          text-align: center;
        }
      }

      // Кнопка во всю ширину: декоративные линии вокруг подписи больше не нужны
      .details-timer-section {
        justify-content: center !important;
        padding: 0;
        border: none;
      }
      .order-details-section {
        flex: 1;
        align-self: stretch;
      }

      // flex сбрасываем: у .v-btn--block он 1 0 auto, а секция - колоночный флекс
      .mobile-details-btn {
        flex: 0 0 auto;
        width: 100%;
        height: 48px;
        border-radius: 10px;
        font-size: 15px;
        font-weight: 500;
        letter-spacing: normal;
        text-transform: none;
        color: #333333;

        &_icon {
          margin-right: 8px;
          width: 18px;
          height: 18px;
          .fill-svg(#8a8f98);
        }
      }
    });
  }
</style>
